// Action constants
import {SET_TOKEN} from './constants';

import roles from './roles';

const DEFAULT_STATE = {
  initialized: false,
  inApp: false,
  token: null,
  tokens: {},
  username: '',
  userID: 0,
  first_name: '',
  last_name: '',
  pin: null,
  roles: roles(),
  users: [],
  userData: {},
};

/**
 * @description :: Reducer for authorization
 * @param {Object} state :: The current state
 * @param {String} type :: The type of action
 * @param {Any} data :: The data bind to the action
 * @return {Object} :: New state
 */
export default (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case SET_TOKEN: {
      return {
        ...state,
        initialized: true,
        ...data,
      };
    }

    default: {
      return state;
    }
  }
};
